import { type AxiosResponse } from 'axios'
import { type GraphQLError } from 'graphql'

export interface GraphQLResponse<T> {
  data?: T
  errors?: GraphQLError[]
  extensions?: Record<string, unknown>
  status: number
}

export interface GraphQLRequestContext<V> {
  query: string
  variables?: V
  operationName: string
}

export class ClientError<T, V, D extends GraphQLResponse<T> = GraphQLResponse<T>> extends Error {
  axiosResponse: AxiosResponse<D>
  response: GraphQLResponse<T>
  request: GraphQLRequestContext<V>

  constructor(apiResponse: AxiosResponse<D>, request: GraphQLRequestContext<V>) {
    const response = apiResponse.data
    const message = `${ClientError.extractMessage<T>(response)}: ${JSON.stringify({
      response,
      request,
    })}`

    super(message)

    Object.setPrototypeOf(this, ClientError.prototype)

    this.axiosResponse = apiResponse
    this.response = response
    this.request = request

    // this is needed as Safari doesn't support .captureStackTrace
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, ClientError)
    }
  }

  private static extractMessage<T>(response: GraphQLResponse<T>): string {
    try {
      return response.errors![0]!.message
    } catch (e) {
      return `GraphQL Error (Code: ${response.status})`
    }
  }
}
